<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mt-2 float-start" style="padding-left: 25px">Detail SO | Doc No : {{ forms.docNo
                  }} | Status :
                    <span class="badge bg-danger"
                      v-if="forms.orderStatus == 'CANCELLED' || forms.orderStatus == 'SYNC FAILED'">{{ forms.orderStatus
                      }}</span>
                    <span class="badge bg-secondary" v-else-if="forms.orderStatus == 'DRAFT'">{{ forms.orderStatus
                    }}</span>
                    <span class="badge bg-info" v-else>{{ forms.orderStatus }}</span>
                  </h6>
                  <!-- <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button> -->

                  <button class="btn btn-danger btn-sm float-end" @click="orderTracking" type="button">
                    <!-- <i class="link-icon" data-feather="track"></i> -->
                    Order Status Tracking
                  </button>
                </div>
                <div class="card-body">


                  <form class="forms-sample" @submit.prevent="submitData" method="POST">


                    <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="home-line-tab" data-bs-toggle="tab" href="#home" role="tab"
                          aria-controls="home" aria-selected="true">Main Info</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="consignee-line-tab" data-bs-toggle="tab" href="#consignee" role="tab"
                          aria-controls="consignee" aria-selected="false">Consignee</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="carrier-line-tab" data-bs-toggle="tab" href="#carrier" role="tab"
                          aria-controls="disabled" aria-selected="false">Carrier</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="udf-line-tab" data-bs-toggle="tab" href="#udf" role="tab"
                          aria-controls="disabled" aria-selected="false">User Defined</a>
                      </li>

                      <li class="nav-item">
                        <a class="nav-link" id="other-line-tab" data-bs-toggle="tab" href="#other" role="other"
                          aria-controls="disabled" aria-selected="false">Other</a>
                      </li>


                    </ul>
                    <div class="tab-content mt-3" id="lineTabContent">
                      <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-line-tab">

                        <div class="row mb-2">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">{{
                              $t('customerId')
                            }}</label>

                            <v-select disabled :options="fetchCustomer" v-model="customer" label="code" return-object
                              @search="asyncCustomer">
                              <template slot="option" slot-scope="option">
                                {{ option.code }} | {{ option.name }}
                              </template>
                            </v-select>

                            <div v-if="errors.customerId">
                              <div v-for="error in errors.customerId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">Warehouse Id</label>

                            <v-select disabled :options="fetchFulfillment" v-model="fulfillment" label="code"
                              return-object @search="asyncSearchFulfillment">
                              <template slot="option" slot-scope="option">
                                {{ option.code }} | {{ option.name }}
                              </template>
                            </v-select>


                            <div v-if="errors.fulfillment_center_id">
                              <div v-for="error in errors.fulfillment_center_id" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">Order Type</label>

                            <v-select disabled :options="fetchOrderType" v-model="orderType" label="name" return-object>
                              <!-- <template slot="option" slot-scope="option">
                                      {{ option.customer_id}} | {{option.code}} | {{option.name}}
                                </template> -->
                            </v-select>
                            <div v-if="errors.orderType">
                              <div v-for="error in errors.orderType" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>

                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">Order Time</label>
                            <!-- <date-range-picker disabled style="width: 100%" control-container-class="form-control"
                              :locale-data="locale" v-model="dateFilter" :opens="opens" :singleDatePicker="true"
                              :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                            </date-range-picker> -->

                            <input readonly type="text" class="form-control" id="soReferenceD" placeholder=""
                              v-model="dateFilter.startDate" />

                            <div v-if="errors.orderTime">
                              <div v-for="error in errors.orderTime" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-3">

                            <label for="defaultconfig" class="col-form-label">Expected Shipment Time</label>
                            <!-- <date-range-picker disabled style="width: 100%" control-container-class="form-control"
                              :locale-data="locale" v-model="expectedShipmentTime1dateFilter" :opens="opens"
                              :singleDatePicker="true" :timePicker24Hour="true" :timePicker="true"
                              :showWeekNumbers="false">
                            </date-range-picker> -->

                            <input readonly type="text" class="form-control" id="soReferenceD" placeholder=""
                              v-model="expectedShipmentTime1dateFilter.startDate" />


                            <div v-if="errors.expectedShipmentTime1">
                              <div v-for="error in errors.expectedShipmentTime1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Channel</label>
                            <input type="text" readonly class="form-control" id="channel" placeholder="Chanel"
                              v-model="forms.chanel" />
                            <div v-if="errors.chanel">
                              <div v-for="error in errors.chanel" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Delivery No</label>
                            <input type="text" readonly class="form-control" id="delivery" placeholder="Delivery No"
                              v-model="forms.deliveryNo" />
                            <div v-if="errors.deliveryNo">
                              <div v-for="error in errors.deliveryNo" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">Doc No</label>
                            <input type="text" readonly class="form-control" id="orderNo" placeholder="Doc No"
                              v-model="forms.docNo" />
                            <div v-if="errors.docNo">
                              <div v-for="error in errors.docNo" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">So Reference A</label>
                            <input type="text" readonly class="form-control" id="stopStation" placeholder="So Reference A"
                              v-model="forms.soReferenceA" />
                            <div v-if="errors.soReferenceA">
                              <div v-for="error in errors.soReferenceA" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>



                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">So Reference B</label>
                            <input type="text" readonly class="form-control" id="soReferenceB"
                              placeholder="SO Reference B" v-model="forms.soReferenceB" />
                            <div v-if="errors.soReferenceB">
                              <div v-for="error in errors.soReferenceB" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">So Reference C</label>
                            <input type="text" readonly class="form-control" id="soReferenceC"
                              placeholder="SO Reference C" v-model="forms.soReferenceC" />
                            <div v-if="errors.soReferenceC">
                              <div v-for="error in errors.soReferenceC" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">So Reference D</label>
                            <input type="text" readonly class="form-control" id="soReferenceD"
                              placeholder="SO Reference D" v-model="forms.soReferenceD" />
                            <div v-if="errors.soReferenceD">
                              <div v-for="error in errors.soReferenceD" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <!-- <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">Customer Ref No</label>
                            <input type="text" class="form-control" id="customerRefNo" placeholder=""
                              v-model="forms.customerRefNo" />
                            <div v-if="errors.customerRefNo">
                              <div v-for="error in errors.customerRefNo" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div> -->
                          <!-- <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Buyer Ref No</label>
                            <input type="text" class="form-control" id="buyerRefNo" placeholder=""
                              v-model="forms.buyerRefNo" />
                            <div v-if="errors.buyerRefNo">
                              <div v-for="error in errors.buyerRefNo" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div> -->
                          <!-- <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Tms Load Id</label>
                            <input type="text" class="form-control" id="tmsLoadId" placeholder=""
                              v-model="forms.tmsLoadId" />
                            <div v-if="errors.tmsLoadId">
                              <div v-for="error in errors.tmsLoadId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div> -->
                        </div>


                        <!--<div class="row mb-2">
                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Route</label>
                              <input type="text" class="form-control" id="route" placeholder="Route"
                                v-model="forms.route" />
                              <div v-if="errors.route">
                                <div v-for="error in errors.route" :key="error" class="alert alert-primary" role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
    
                            </div>
                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Stop Station</label>
                              <input type="text" class="form-control" id="stopStation" placeholder="Stop Station"
                                v-model="forms.stopStation" />
                              <div v-if="errors.stopStation">
                                <div v-for="error in errors.stopStation" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
    
                            </div>
                        </div>-->


                        <div class="row mb-2">
                          <div class="col-lg-12">
                            <label for="defaultconfig" class="col-form-label">Note</label>
                            <textarea disabled class="form-control" name="noteTxt" v-model="forms.noteText"></textarea>
                            <div v-if="errors.noteText">
                              <div v-for="error in errors.noteText" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="row card mt-5">
                          <div class="card-header">
                            <h5 class="float-start">Detail <span class="wajib">*</span></h5>
                            <!-- 
                            <button class="
                            btn btn-success btn-icon
                            text-white
                            fw-bolder
                            btn-icon-text
                            float-end
                          " @click="addFieldDetail()" type="button"> <i class="link-icon" data-feather="plus"></i>
                            </button> -->

                          </div>

                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover" style="height: 300px">
                                <thead>

                                  <tr>
                                    <th>#</th>
                                    <th width="450px" class="required">SKU</th>
                                    <th width="150px">SKU Description</th>
                                    <th class="required">Qty Order</th>
                                    <th class="required">Qty Shipped</th>
                                    <th>Uom</th>
                                    <th>Price</th>
                                    <th>LotAtt01</th>
                                    <th>LotAtt02</th>
                                    <th>LotAtt03</th>
                                    <th>LotAtt04</th>
                                    <th>LotAtt05</th>
                                    <th>LotAtt06</th>
                                    <th>LotAtt07</th>
                                    <th>LotAtt08</th>
                                    <th>LotAtt09</th>
                                    <th>LotAtt10</th>
                                    <th>LotAtt11</th>
                                    <th>LotAtt12</th>
                                    <th>LotAtt13</th>
                                    <th>LotAtt14</th>
                                    <th>LotAtt15</th>
                                    <th>LotAtt16</th>
                                    <th>LotAtt17</th>
                                    <th>LotAtt18</th>
                                    <th>LotAtt19</th>
                                    <th>LotAtt20</th>
                                    <th>LotAtt21</th>
                                    <th>LotAtt22</th>
                                    <th>LotAtt23</th>
                                    <th>LotAtt24</th>
                                    <th>Udf01</th>
                                    <th>Udf02</th>
                                    <th>Udf03</th>
                                    <th>Udf04</th>
                                    <th>Udf05</th>
                                    <th>Udf06</th>
                                    <th>Dedi01</th>
                                    <th>Dedi02</th>
                                    <th>Dedi03</th>
                                    <th>Dedi04</th>
                                    <th>Dedi05</th>
                                    <th>Dedi06</th>
                                    <th>Dedi07</th>
                                    <th>Dedi08</th>
                                    <th>Dedi09</th>
                                    <th>Dedi10</th>
                                    <th>Dedi11</th>
                                    <th>Dedi12</th>
                                    <th>Dedi13</th>
                                    <th>Dedi14</th>
                                    <th>Dedi15</th>
                                    <th>Dedi16</th>
                                    <th>Dedi17</th>
                                    <th>Dedi18</th>
                                    <th>Dedi19</th>
                                    <th>Dedi20</th>
                                    <th>Note Text</th>
                                    <th>Location</th>
                                    <th>RotationId</th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr v-for="(input, index) in this.detailSo" :key="`phoneInput-${index}`">
                                    <th>{{ index + 1 }}</th>

                                    <td width="200px">


                                      {{ input.sku }}


                                    </td>

                                    <td>

                                      {{ input.skuDescr1 }}
                                      <!-- <input type="number" v-model="input.volume" class="form-control" style="width: 100px" /> -->
                                    </td>

                                    <td>
                                      <!-- <input type="number" v-model="input.qtyOrdered" class="form-control" required
                                        style="width: 100px" /> -->
                                      {{ input.qtyOrdered }}
                                    </td>


                                    <td>
                                      <!-- <input type="number" v-model="input.qtyOrdered" class="form-control" required
                                        style="width: 100px" /> -->
                                      {{ input.qtyShipped }}
                                    </td>


                                    


                                    <td>
                                      <!-- <input type="text" v-model="input.Uom" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.uom }}
                                    </td>

                                    <td>
                                      {{ input.price }}
                                      <!-- <input type="number" v-model="input.price" class="form-control"
                                        style="width: 100px" /> -->
                                    </td>

                                    <td>
                                      {{ input.lotAtt01 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt02 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt03 }}
                                    </td>


                                    <td>
                                      {{ input.lotAtt04 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt05 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt06 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt07 }}
                                    </td>



                                    <td>
                                      {{ input.lotAtt08 }}
                                      <!-- <input type="text" v-model="input.StockConditionCode" class="form-control"
                                        style="width: 100px" /> -->

                                      <!-- <multiselect style="width:200px;"  v-model="input.StockConditionCode" :options="fetchStockCondition"
                                       label="name" track-by="name"
                                        placeholede="Please Select">
                                        <span slot="noResult">Oops! No elements found. Consider changing the
                                          search query.</span>
                                      </multiselect> -->

                                    </td>




                                    <td>
                                      {{ input.LotAtt09 }}
                                      <!-- <input type="text" v-model="input.LotAtt07" class="form-control"
                                        style="width: 100px" /> -->
                                    </td>


                                    <td>
                                      {{ input.lotAtt10 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt11 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt12 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt13 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt14 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt15 }}
                                    </td>


                                    <td>
                                      {{ input.lotAtt16 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt17 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt18 }}
                                    </td>


                                    <td>
                                      {{ input.lotAtt19 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt20 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt21 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt22 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt23 }}
                                    </td>

                                    <td>
                                      {{ input.lotAtt24 }}
                                    </td>



                                    <td>
                                      {{ input.userDefine1 }}
                                    </td>

                                    <td>
                                      {{ input.userDefine2 }}
                                    </td>

                                    <td>
                                      {{ input.userDefine3 }}
                                    </td>

                                    <td>
                                      {{ input.userDefine4 }}
                                    </td>

                                    <td>
                                      {{ input.userDefine5 }}
                                    </td>

                                    <td>
                                      {{ input.userDefine6 }}
                                    </td>

                                    <td>
                                      {{ input.dedi01 }}
                                    </td>

                                    <td>
                                      {{ input.dedi02 }}
                                    </td>

                                    <td>
                                      {{ input.dedi03 }}
                                    </td>

                                    <td>
                                      {{ input.dedi04 }}
                                    </td>

                                    <td>
                                      {{ input.dedi05 }}
                                    </td>

                                    <td>
                                      {{ input.dedi06 }}
                                    </td>

                                    <td>
                                      {{ input.dedi07 }}
                                    </td>

                                    <td>
                                      {{ input.dedi08 }}
                                    </td>

                                    <td>
                                      {{ input.dedi09 }}
                                    </td>

                                    <td>
                                      {{ input.dedi10 }}
                                    </td>

                                    <td>
                                      {{ input.dedi11 }}
                                    </td>

                                    <td>
                                      {{ input.dedi12 }}
                                    </td>


                                    <td>
                                      {{ input.dedi13 }}
                                    </td>

                                    <td>
                                      {{ input.dedi14 }}
                                    </td>

                                    <td>
                                      {{ input.dedi15 }}
                                    </td>

                                    <td>
                                      {{ input.dedi16 }}
                                    </td>

                                    <td>
                                      {{ input.dedi17 }}
                                    </td>

                                    <td>
                                      {{ input.dedi18 }}
                                    </td>

                                    <td>
                                      {{ input.dedi19 }}
                                    </td>

                                    <td>
                                      {{ input.dedi20 }}
                                    </td>


                                    <td>
                                      {{ input.noteText }}
                                      <!-- <input type="text" v-model="input.noteText" class="form-control"
                                        style="width: 100px" /> -->
                                    </td>
                                    <td>
                                      {{ input.location }}
                                    </td>
                                    <td>
                                      {{ input.rotationId }}
                                    </td>


                                  </tr>
                                </tbody>

                                <tfoot></tfoot>
                              </table>
                            </div>
                          </div>
                        </div>


                      </div>
                      <div class="tab-pane fade" id="consignee" role="tabpanel" aria-labelledby="consignee-line-tab">
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">Consignee Id</label>
                            <input readonly type="text" class="form-control" id="consigneeId" placeholder="Consignee ID"
                              v-model="forms.consigneeId" />

                            <div v-if="errors.customerId">
                              <div v-for="error in errors.consigneeId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">Consignee Name</label>
                            <input readonly type="text" class="form-control" id="consigneeName"
                              placeholder="Consignee Name" v-model="forms.consigneeName" />

                            <div v-if="errors.customerName">
                              <div v-for="error in errors.consigneeName" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-5">
                            <label for="defaultconfig" class="col-form-label">Consignee Email</label>
                            <input readonly type="text" class="form-control" id="consigneeemail"
                              placeholder="Consignee Name" v-model="forms.consigneeEmail" />

                            <div v-if="errors.consigneeEmail">
                              <div v-for="error in errors.consigneeEmail" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Country</label>
                            <input readonly type="text" class="form-control" id="consigneeCountry"
                              placeholder="Consignee Name" v-model="forms.consigneeCountry" />

                            <div v-if="errors.consigneeCountry">
                              <div v-for="error in errors.consigneeCountry" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Province</label>
                            <input readonly type="text" class="form-control" id="consigneeProvince"
                              placeholder="Consignee Name" v-model="forms.consigneeProvince" />

                            <div v-if="errors.consigneeProvince">
                              <div v-for="error in errors.consigneeProvince" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">City</label>
                            <input readonly type="text" class="form-control" id="consigneeCity"
                              placeholder="Consignee Name" v-model="forms.consigneeCity" />

                            <div v-if="errors.consigneeCity">
                              <div v-for="error in errors.consigneeCity" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">District</label>
                            <input readonly type="text" class="form-control" id="consigneeDistrict"
                              placeholder="Consignee Name" v-model="forms.consigneeDistrict" />

                            <div v-if="errors.consigneeDistrict">
                              <div v-for="error in errors.consigneeDistricty" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Street</label>
                            <input readonly type="text" class="form-control" id="consigneeStreet"
                              placeholder="Consignee Name" v-model="forms.consigneeStreet" />

                            <div v-if="errors.consigneeStreet">
                              <div v-for="error in errors.consigneeStreet" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Zip</label>
                            <input readonly type="text" class="form-control" id="consigneeZip"
                              placeholder="Consignee Name" v-model="forms.consigneeZip" />

                            <div v-if="errors.consigneeZip">
                              <div v-for="error in errors.consigneeZip" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label required">Phone 1</label>
                            <input readonly type="text" class="form-control" id="consigneeTel1"
                              placeholder="Consignee Phone 1" v-model="forms.consigneeTel1" />

                            <div v-if="errors.consigneeTel1">
                              <div v-for="error in errors.consigneeTel1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Phone 2</label>
                            <input readonly type="text" class="form-control" id="consigneeTel2"
                              placeholder="Consignee Phone 2" v-model="forms.consigneeTel2" />

                            <div v-if="errors.consigneeTel2">
                              <div v-for="error in errors.consigneeTel2" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Contact</label>
                            <input type="text" readonly class="form-control" id="consigneeContact"
                              placeholder="Consignee Contact" v-model="forms.consigneeContact" />

                            <div v-if="errors.consigneeContact">
                              <div v-for="error in errors.consigneeContact" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6">
                            <label for="defaultconfig" class="col-form-label required">Consignee Address 1</label>
                            <input readonly type="text" class="form-control" id="consigneeAddress21" placeholder="Address"
                              v-model="forms.consigneeAddress1" />

                            <div v-if="errors.consigneeAddress1">
                              <div v-for="error in errors.consigneeAddress1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>




                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Consignee Address 2</label>
                            <input readonly type="text" class="form-control" id="consigneeAddress2" placeholder="Address"
                              v-model="forms.consigneeAddress2" />

                            <div v-if="errors.consigneeAddress2">
                              <div v-for="error in errors.consigneeAddress2" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Consignee Address 3</label>
                            <input readonly type="text" class="form-control" id="consigneeAddress3" placeholder="Address"
                              v-model="forms.consigneeAddress3" />

                            <div v-if="errors.consigneeAddress2">
                              <div v-for="error in errors.consigneeAddress3" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Consignee Address 4</label>
                            <input type="text" readonly class="form-control" id="consigneeAddress4" placeholder="Address"
                              v-model="forms.consigneeAddress4" />

                            <div v-if="errors.consigneeAddress4">
                              <div v-for="error in errors.consigneeAddress4" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>









                      </div>

                      <div class="tab-pane fade" id="udf" role="tabpanel" aria-labelledby="udf-line-tab">

                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">UDF 1</label>
                            <input type="text" readonly class="form-control" id="udf1" placeholder=""
                              v-model="forms.userDefine1" />
                            <div v-if="errors.userDefine1">
                              <div v-for="error in errors.userDefine1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">UDF 2</label>
                            <input type="text" readonly class="form-control" id="udf2" placeholder=""
                              v-model="forms.userDefine2" />
                            <div v-if="errors.userDefine2">
                              <div v-for="error in errors.udf2" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">UDF 3</label>
                            <input type="text" readonly class="form-control" id="udf3" placeholder=""
                              v-model="forms.userDefine3" />
                            <div v-if="errors.userDefine3">
                              <div v-for="error in errors.userDefine3" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">UDF 4</label>
                            <input type="text" readonly class="form-control" id="udf4" placeholder=""
                              v-model="forms.userDefine4" />
                            <div v-if="errors.userDefine4">
                              <div v-for="error in errors.userDefine4" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">UDF 5</label>
                            <input type="text" readonly class="form-control" id="udf5" placeholder=""
                              v-model="forms.userDefine5" />
                            <div v-if="errors.userDefine5">
                              <div v-for="error in errors.userDefine5" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">UDF 6</label>
                            <input type="text" readonly class="form-control" id="udf6" placeholder=""
                              v-model="forms.userDefine6" />
                            <div v-if="errors.userDefine6">
                              <div v-for="error in errors.userDefine6" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>



                      <div class="tab-pane fade show" id="carrier" role="tabpanel" aria-labelledby="carrier-line-tab">
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Id</label>
                            <input type="text" readonly class="form-control" id="carrierId" placeholder=""
                              v-model="forms.carrierId" />

                            <div v-if="errors.carrierId">
                              <div v-for="error in errors.carrierId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Name</label>
                            <input type="text" readonly class="form-control" id="carrierName" placeholder=""
                              v-model="forms.carrierName" />

                            <div v-if="errors.carrierName">
                              <div v-for="error in errors.carrierName" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Email</label>
                            <input type="text" readonly class="form-control" id="carrierEmail" placeholder=""
                              v-model="forms.carrierEmail" />

                            <div v-if="errors.carrierEmail">
                              <div v-for="error in errors.carrierEmail" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Contact</label>
                            <input type="text" readonly class="form-control" id="carrierContact" placeholder=""
                              v-model="forms.carrierContact" />

                            <div v-if="errors.carrierContact">
                              <div v-for="error in errors.carrierContact" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Fax</label>
                            <input type="text" readonly class="form-control" id="carrierFax" placeholder=""
                              v-model="forms.carrierFax" />

                            <div v-if="errors.carrierFax">
                              <div v-for="error in errors.carrierFax" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Tel 1</label>
                            <input type="text" readonly class="form-control" id="carrierTel1" placeholder=""
                              v-model="forms.carrierTel1" />

                            <div v-if="errors.carrierTel1">
                              <div v-for="error in errors.carrierTel1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row mb-3">

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Tel 2</label>
                            <input type="text" readonly class="form-control" id="carrierTel1" placeholder=""
                              v-model="forms.carrierTel2" />

                            <div v-if="errors.carrierTel2">
                              <div v-for="error in errors.carrierTel1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Carrier Address 1</label>
                            <input type="text" readonly class="form-control" id="carrierAddress1" placeholder=""
                              v-model="forms.carrierAddress1" />

                            <div v-if="errors.carrierAddress1">
                              <div v-for="error in errors.carrierAddress1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Address 2</label>
                            <input type="text" readonly class="form-control" id="carrierAddress2" placeholder=""
                              v-model="forms.carrierAddress2" />

                            <div v-if="errors.carrierAddress2">
                              <div v-for="error in errors.carrierAddress2" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Address 3</label>
                            <input type="text" readonly class="form-control" id="carrierAddress3" placeholder=""
                              v-model="forms.carrierAddress3" />

                            <div v-if="errors.carrierAddress3">
                              <div v-for="error in errors.carrierAddress3" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Address 4</label>
                            <input type="text" readonly class="form-control" id="carrierAddress4" placeholder=""
                              v-model="forms.carrierAddress4" />

                            <div v-if="errors.carrierAddress4">
                              <div v-for="error in errors.carrierAddress4" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>


                        <div class="row mb-3">

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Country</label>
                            <input type="text" readonly class="form-control" id="carrierCountry" placeholder=""
                              v-model="forms.carrierCountry" />

                            <div v-if="errors.carrierCountry">
                              <div v-for="error in errors.carrierCountry" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Province</label>
                            <input type="text" readonly class="form-control" id="carrierProvince" placeholder=""
                              v-model="forms.carrierProvince" />

                            <div v-if="errors.carrierProvince">
                              <div v-for="error in errors.carrierProvince" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier City</label>
                            <input type="text" readonly class="form-control" id="carrierCity" placeholder=""
                              v-model="forms.carrierCity" />

                            <div v-if="errors.carrierCity">
                              <div v-for="error in errors.carrierCity" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier District</label>
                            <input type="text" readonly class="form-control" id="carrierDistrict" placeholder=""
                              v-model="forms.carrierDistrict" />

                            <div v-if="errors.carrierDistrict">
                              <div v-for="error in errors.carrierDistrict" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Street</label>
                            <input type="text" readonly class="form-control" id="carrierStreet" placeholder=""
                              v-model="forms.carrierStreet" />

                            <div v-if="errors.carrierStreet">
                              <div v-for="error in errors.carrierStreet" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Carrier Zip</label>
                            <input type="text" readonly class="form-control" id="carrierZip" placeholder=""
                              v-model="forms.carrierZip" />

                            <div v-if="errors.carrierZip">
                              <div v-for="error in errors.carrierZip" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>






                      </div>


                      <div class="tab-pane fade show" id="other" role="tabpanel" aria-labelledby="other-line-tab">
                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi01</label>
                            <input type="text" readonly class="form-control" id="hedi01" placeholder=""
                              v-model="forms.hedi01" />

                            <div v-if="errors.hedi01">
                              <div v-for="error in errors.hedi01" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi02</label>
                            <input type="text" readonly class="form-control" id="hedi02" placeholder=""
                              v-model="forms.hedi02" />

                            <div v-if="errors.hedi02">
                              <div v-for="error in errors.hedi02" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi03</label>
                            <input type="text" readonly class="form-control" id="hedi02" placeholder=""
                              v-model="forms.hedi03" />

                            <div v-if="errors.hedi03">
                              <div v-for="error in errors.hedi03" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi04</label>
                            <input type="text" readonly class="form-control" id="hedi04" placeholder=""
                              v-model="forms.hedi04" />

                            <div v-if="errors.hedi04">
                              <div v-for="error in errors.hedi04" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi05</label>
                            <input type="text" readonly class="form-control" id="hedi05" placeholder=""
                              v-model="forms.hedi05" />

                            <div v-if="errors.hedi05">
                              <div v-for="error in errors.hedi05" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>



                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi06</label>
                            <input type="text" readonly class="form-control" id="hedi01" placeholder=""
                              v-model="forms.hedi06" />

                            <div v-if="errors.hedi06">
                              <div v-for="error in errors.hedi06" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi07</label>
                            <input type="text" readonly class="form-control" id="hedi02" placeholder=""
                              v-model="forms.hedi07" />

                            <div v-if="errors.hedi07">
                              <div v-for="error in errors.hedi07" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi08</label>
                            <input type="text" readonly class="form-control" id="hedi08" placeholder=""
                              v-model="forms.hedi08" />

                            <div v-if="errors.hedi08">
                              <div v-for="error in errors.hedi08" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi09</label>
                            <input type="text" readonly class="form-control" id="hedi09" placeholder=""
                              v-model="forms.hedi09" />

                            <div v-if="errors.hedi11">
                              <div v-for="error in errors.hedi09" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi10</label>
                            <input type="text" readonly class="form-control" id="hedi10" placeholder=""
                              v-model="forms.hedi10" />

                            <div v-if="errors.hedi10">
                              <div v-for="error in errors.hedi10" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>


                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi11</label>
                            <input type="text" readonly class="form-control" id="hedi11" placeholder=""
                              v-model="forms.hedi11" />

                            <div v-if="errors.hedi11">
                              <div v-for="error in errors.hedi06" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi12</label>
                            <input type="text" readonly class="form-control" id="hedi12" placeholder=""
                              v-model="forms.hedi12" />

                            <div v-if="errors.hedi12">
                              <div v-for="error in errors.hedi12" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi13</label>
                            <input type="text" readonly class="form-control" id="hedi13" placeholder=""
                              v-model="forms.hedi13" />

                            <div v-if="errors.hedi13">
                              <div v-for="error in errors.hedi13" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi14</label>
                            <input type="text" readonly class="form-control" id="hedi09" placeholder=""
                              v-model="forms.hedi14" />

                            <div v-if="errors.hedi14">
                              <div v-for="error in errors.hedi14" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi15</label>
                            <input type="text" readonly class="form-control" id="hedi15" placeholder=""
                              v-model="forms.hedi15" />

                            <div v-if="errors.hedi15">
                              <div v-for="error in errors.hedi15" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>



                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi16</label>
                            <input type="text" readonly class="form-control" id="hedi16" placeholder=""
                              v-model="forms.hedi16" />

                            <div v-if="errors.hedi16">
                              <div v-for="error in errors.hedi16" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi17</label>
                            <input type="text" readonly class="form-control" id="hedi17" placeholder=""
                              v-model="forms.hedi17" />

                            <div v-if="errors.hedi17">
                              <div v-for="error in errors.hedi17" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi18</label>
                            <input type="text" readonly class="form-control" id="hedi18" placeholder=""
                              v-model="forms.hedi18" />

                            <div v-if="errors.hedi18">
                              <div v-for="error in errors.hedi18" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi19</label>
                            <input readonly type="text" class="form-control" id="hedi19" placeholder=""
                              v-model="forms.hedi19" />

                            <div v-if="errors.hedi14">
                              <div v-for="error in errors.hedi19" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi20</label>
                            <input type="text" readonly class="form-control" id="hedi20" placeholder=""
                              v-model="forms.hedi20" />

                            <div v-if="errors.hedi20">
                              <div v-for="error in errors.hedi20" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>

                      </div>




                    </div>




                    <div class="card-footer">
                      <button class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          " @click="backForm" type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;

                      <div class="float-end">
                        <a href="#" class="btn btn-primary btn-sm "
                          v-if="forms.orderStatus == 'DRAFT' || forms.orderStatus == 'SYNC FAILED'"
                          @click="updateStatus(forms.idOrderHeader)">
                          {{ $t("submitFormTxt") }}
                          <i class="link-icon" data-feather="save"></i>
                        </a>
                        &nbsp;&nbsp;&nbsp;
                        <a href="#" class="btn btn-danger btn-sm "
                          v-if="forms.orderStatus == 'DRAFT' || forms.orderStatus == 'NEW' || forms.orderStatus == 'RECEIVING' || forms.orderStatus=='PACKING'"
                          @click="cancelStatus(forms.idOrderHeader)">
                            {{ $t("cancel_order_txt") }}
                          <i class="link-icon" data-feather="close"></i>
                        </a>

                        &nbsp;&nbsp;&nbsp;
                        <a href="#" class="btn btn-warning btn-sm "
                          v-if="forms.orderStatus == 'CANCELLED' || forms.orderStatus == 'NEW' || forms.orderStatus == 'RECEIVING'"
                          @click="reactedStatus(forms.idOrderHeader)">
                            {{ $t("draft_order_txt") }}
                          <i class="link-icon" data-feather="close"></i>
                        </a>


                        &nbsp;&nbsp;&nbsp;
                        <a href="#" class="btn btn-secondary btn-sm " v-if="forms.orderStatus == 'DRAFT'"
                          @click="editOrder(forms.idOrderHeader)">
                        
                          {{ $t("edit_order_txt") }}
                          <i class="link-icon" data-feather="edit"></i>
                        </a>


                        &nbsp;&nbsp;&nbsp;


                        <button type="button" v-if="forms.orderStatus == 'RECEIVING'" class="btn btn-secondary"
                          @click="manualShipped()">
                          <i class="link-icon" data-feather="edit"></i>
                          Manual Shipped
                        </button>



                        &nbsp;&nbsp;&nbsp;

                        <!-- PACKING','PACKING COMPLETED','SHIPPED' -->
                          <button type="button" v-if="forms.orderStatus == 'PACKING' || forms.orderStatus == 'PACKING COMPLETED' || forms.orderStatus == 'SHIPPED'" class="btn btn-secondary"
                            @click="interfaceBtn(forms.idOrderHeader)">
                            <i class="link-icon" data-feather="edit"></i>
                            Interface
                          </button>



                      </div>

                    </div>
                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>

          <modal name="modalOrderTracking" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
              role="dialog">
              <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">

                  <div class="modal-header">
                    <h5 class="modal-title" id="massUploadMasterSKU">Tracking Order Status</h5>
                    <button type="button" class="btn-close" aria-label="btn-close"
                      @click.prevent="removeModals()"></button>
                  </div>
                  <div class="modal-body">
                    <div class="table-responsive" v-if="!isLoadingStatus">
                      <table class="table table-hover">
                        <thead>
                          <th>PIC</th>
                          <th>Status</th>
                          <th>Remarks</th>
                          <th>Update Time</th>
                        </thead>
                        <tbody>
                          <tr v-for="(trackingOrderStatus, index) in trackingOrderStatus " :key="index">
                            <th>{{ trackingOrderStatus.addWho }}</th>
                            <th>{{ trackingOrderStatus.orderStatus }}</th>
                            <th>{{ trackingOrderStatus.remarks }}</th>
                            <th>{{ format_date(trackingOrderStatus.editTime) }}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>


                    <div v-else class="d-flex align-items-center">
                      <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div>


                  </div>
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                      this.$t("close_txt") }}</button>

                  </div>

                </div>
              </div>
            </div>
          </modal>


          <manualShipped :showModal="showModalNow" :data="forms.so_details" :idOrderHeader="forms.idOrderHeader"
            @closeModal="closeMyModal"></manualShipped>

        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import manualShipped from "@/components/flux_oms/so/ModalManualShipped"
// import DateRangePicker from "vue2-daterange-picker";
// import multiselect from "vue-multiselect";

export default {
  name: "CmlTarifAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    manualShipped
    // DateRangePicker,
    // multiselect
  },
  data() {
    const startDate = new Date();// new Date();
    const endDate = new Date();

    return {
      typeData: "so",
      dateFilter: {
        startDate,
        endDate,
      },

      showModalNow: false,

      trackingOrderStatus: [],

      expectedShipmentTime1dateFilter: {
        startDate,
        endDate,
      },

      opens: "center",
      locale: {
        format: "yyyy-mm-dd H:MM:ss",
      },

      localeDetail: {
        format: "yyyy-mm-dd",
      },

      highlighted: {

        dates: [ // Highlight an array of dates
          new Date(),
        ],

      },

      digit: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: '',
        precision: 5,
        masked: false
      },
      fetchStockCondition: [],
      detailSo: [],
      orderType: '',
      fetchOrderType: [],
      shelfLifeUnit: {},
      shelfLifeType: {},
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      userRole: "",
      companyCode: "",
      fetchStatus: ['ACTIVE', 'DEACTIVE'],
      fetchmultiWhFlag: ['Y', 'N'],
      fetchCustomer: [],
      fetchFulfillment: [],
      customer: "",
      fulfillment: "",
      fetchShelfLifeType: [],
      fetchShelfLifeUnit: [],
      fetchSku: [],
      activeFlag: false,
      shelfLifeFlag: false,
      kitFlag: false,
      freePickGift: false,
      isLoadingStatus: false,
      forms: {},
    };
  },
  watch: {},
  methods: {



    loadCustomer() {

      const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    loadFullfilment() {

      const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    loadOrderType() {
      const baseURI = this.$settings.endPointFluxOms + "v2/so/type?code&name";
      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchOrderType = response.data.datas;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    loadStockCondition() {
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-wms-code?type=DMG_FLG";
      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchStockCondition = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    closeMyModal() {
      this.showModalNow = false;
      this.loadData(this.forms.idOrderHeader);
    },

    loadSKU(params) {


      this.fetchSku = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/index" + params;
      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchSku = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    asyncSearchSku(ev) {
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;
      return this.$http.get(baseURI).then((response) => {
        this.fetchSKU = response.data.datas.data;
      });
    },

    // asyncSearchSku(ev) {
    //   console.log();
    // // this.fetchSku=[];
    // // const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;

    // // return this.$http
    // //   .get(
    // //     baseURI, { timeout: 10000 }
    // //   )
    // //   .then((response) => {
    // //     this.fetchSku = response.data.datas;
    // //   }).catch(error => {

    // //     if (error.code == "ECONNABORTED") {
    // //       this.error("Please Check Your Internet Connection");
    // //     }

    // //   });
    // },

    manualShipped() {
      this.showModalNow = !this.showModalNow;
      console.log(this.showModalNow);
    },

    updateStatus(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Update Status Order',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // var formData = {
          //   orderStatus: 'NEW',
          // };
          const baseURI =
            this.$settings.endPointFluxOms + "v2/so/submitted/" + id;
          this.$http
            .get(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/so-outbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },



    interfaceBtn(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Update interface',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            interfaceStatus:0
          }
          const baseURI =
            this.$settings.endPointFluxOms + "v2/so/interface-status/"+id;
          this.$http
            .patch(baseURI,formData, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                //window.location.href = "/flux-oms/so-outbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    editOrder(id) {
      var params = this.$onRandom(id);
      window.location.href = "/flux-oms/so-outbound/edit/" + params;
    },

    cancelStatus(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Cancel Status Order',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // var formData = {};
          const baseURI =
            this.$settings.endPointFluxOms + "v2/so/cancelled/" + id;
          this.$http
            .get(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/so-outbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    orderTracking() {

      this.$modal.show('modalOrderTracking');
      // var params = this.$onBehind(this.$route.params.id);
      // this.loadDataOrderStatus(params);
    },


    removeModals() {
      this.$modal.hide('modalOrderTracking')

    },


    format_date(value) {
      if (value) {
        return this.$moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
      }
    },


    loadDataOrderStatus(id) {

      const baseURI = this.$settings.endPointFluxOms + "v2/so/detail-order-tracking/" + id;

      return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        this.isLoadingStatus = false;
        this.trackingOrderStatus = response.data.datas;
        this.$modal.show('modalOrderTracking');
        // this.fulfillment    = response.data.datas.fulfillment

      }).catch(error => {

        if (error.code == "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else {

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }

        }

      });
    },


    loadData(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPointFluxOms + "v2/so/detail/" + id;

      return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        this.isLoading = false;
        this.forms = response.data.datas;

        this.customer = {
          code: this.forms.customerId
        };

        this.fulfillment = {
          fulfillment_center_id: this.forms.fulfillment.fulfillment_center_id,
          code: this.forms.fulfillment.code,
          name: this.forms.fulfillment.name,
        };
        this.dateFilter = {
          startDate: this.forms.orderTime,
          endDate: this.forms.orderTime

        },


          this.expectedShipmentTime1dateFilter = {
            startDate: this.forms.expectedShipmentTime1,
            endDate: this.forms.expectedShipmentTime1
          },


        this.trackingOrderStatus = this.forms.so_trackings;     
        



        this.orderType = {
          code: this.forms?.order_type?.code,
          name: this.forms?.order_type?.name,
        };
        

        this.detailSo = this.forms.so_details;
        


        // this.fulfillment    = response.data.datas.fulfillment

      }).catch(error => {

        this.loading();

        if (error.code == "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else {

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }

        }

      });
    },


    reactedStatus(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'For Reacted ?',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // var formData = {};
          const baseURI =
            this.$settings.endPointFluxOms + "v2/so/reacted/" + id;
          this.$http
            .get(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/so-outbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    cekData(index, fieldType) {
      console.log(index);
      console.log(fieldType);
      fieldType[index].skuDescr1 = fieldType[index].sku.skuDescr1;
      // fieldType[index].lading_length = fieldType[index].sku.pcs_length;
      // fieldType[index].lading_width = fieldType[index].sku.pcs_width;
      // fieldType[index].lading_height = fieldType[index].sku.pcs_height;
      // //fieldType[index].package_type = fieldType[index].sku.package_code;    
      // fieldType[index].lading_qty = fieldType[index].sku.lading_qty;
      // fieldType[index].net_weight = fieldType[index].sku.net_weight;
      // fieldType[index].weight = fieldType[index].sku.weight;
      // fieldType[index].volume = fieldType[index].sku.volume;
      // //fieldType[index].qty = 0;  
      // this.loadLadingType(fieldType[index].sku.sku_id);
    },


    asyncSearchFulfillment(ev) {
      this.fetchFulfillment = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment?code=" + ev;

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
          //console.log(this.fetchFulfillment);
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms?code=" + code;

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    resetForm() {

      this.forms = [];

    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.userRole = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'SoController') {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
      this.loadFullfilment();
      this.loadCustomer();
      this.loadOrderType();
      // this.loadSKU();
      // this.loadStockCondition();
      // this.loadShelfLifeType();
      // this.loadShelfLifeUnit();

    },

    backForm() {
      window.location.href = "/flux-oms/so-outbound";
    },



    submitData() {
      this.isLoading = true;



      this.forms.customer_id = this.customer.customer_id;
      this.forms.customerId = this.customer.code;

      this.forms.fulfillment_center_id = this.fulfillment.fulfillment_center_id;
      this.forms.warehouseId = this.fulfillment.code;
      this.forms.orderType = this.orderType.code;
      this.forms.orderTime = this.$moment(String(this.dateFilter.startDate)).format('YYYY-MM-DD H:mm:ss');
      this.forms.expectedShipmentTime1 = this.$moment(String(this.expectedShipmentTime1dateFilter.startDate)).format('YYYY-MM-DD H:mm:ss');
      var DOC_ORDER_DETAILS = [];


      for (let index = 0; index < this.detailSo.length; index++) {
        const element = {
          "idOrderHeader": index + 1,
          "sku": this.detailSo[index].sku.sku,
          "qtyOrdered": this.detailSo[index].qtyOrdered,
          "StockConditionCode": this.detailSo[index].StockConditionCode.code,
          "price": this.detailSo[index].price,
          "ProdDate": this.$moment(String(this.detailSo[index].ProdDate.startDate)).format('YYYY-MM-DD'),
          "ExpDate": this.$moment(String(this.detailSo[index].ExpDate.startDate)).format('YYYY-MM-DD'),
          "WhseDate": this.$moment(String(this.detailSo[index].WhseDate.startDate)).format('YYYY-MM-DD'),
          "Batch": this.detailSo[index].Batch,
          "lotAtt07": this.detailSo[index].lotAtt07,
          "Uom": this.detailSo[index].Uom,
          "udf01": this.detailSo[index].udf01,
          "noteText": this.detailSo[index].noteText
        }

        DOC_ORDER_DETAILS.push(element);

      }

      this.forms.DOC_ORDER_DETAILS = DOC_ORDER_DETAILS;

      console.log(this.forms);
      const baseURI = this.$settings.endPointFluxOms + "v2/so/store";
      this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
        this.loading();
        if (response.data.status === 200) {
          //this.resetForm();
          this.isLoading = false;
          this.errors = [];
          //console.log(response.data.datas.user_id);
          //var params = this.$onRandom(response.data.datas.BAS_SKU_ID);
          window.location.href = "/flux-oms/so-outbound";
          this.success('Berhasil');
        } else {
          this.isLoading = false;
          this.errors = response.data.errors;
          this.resultError(response.data.errors);
        }
      }).catch(error => {
        this.loading();
        this.isLoading = false;
        if (error.code == "ECONNABORTED") {
          this.error("Please Check Your Internet Connection");
        }

        if (error.response) {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.resultError(error.response.data.errors);
          } else if (error.response.status === 401) {
            this.logout();
          } else if (error.response.status === 403) {
            this.$router.push("/authorized-error");
          } else if (error.response.status === 500) {
            this.$router.push('/server-error');
          } else {
            this.$router.push('/page-not-found');
          }
        }
        //this.resetForm();
      });

    },


    addFieldDetail() {
      const startDate = new Date();// new Date();
      const endDate = new Date();
      this.detailSo.push({
        "customerId": this.forms?.customerId,
        "warehouseId": this.forms?.fulfillment_center_id,
        "orderNo": this.forms?.orderNo,
        "sku": "",
        "skuDescr1": "",
        "qtyOrdered": 0,
        "StockConditionCode": '',
        "price": 0,
        "ProdDate": {
          startDate,
          endDate,
        },
        "ExpDate": {
          startDate,
          endDate,
        },
        "WhseDate": {
          startDate,
          endDate,
        },
        "Batch": "",
        "lotAtt07": "",
        "Uom": "",
        "udf01": "",
        "noteText": ""
      });

      console.log(this.detailSo);
    },

    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },

    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();

    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);


  },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>